import React, { useEffect, useState } from 'react';
import { ItemGroupForm } from '../../../Components/Form';
import FormLayout from '../../../Components/Layout/FormLayout';
import { NewItemIcon } from '../../../Assets/Navigation/NavigationIcons';
import { useTranslation } from 'react-i18next';
import RawItemform from '../../../Components/Form/rawItemForm/RawItemform';

const AddrawItem = ({ handleToast }) => {
  const { t } = useTranslation();
  const [, setStep] = useState(false);

  useEffect(() => {
    document.title = "Create Raw Item";
  }, []);

  const handleStep = () => setStep(true);
  return (
    <FormLayout
      title="Create Raw Item"
      Icon={NewItemIcon}
      closeUrl="/item-groups"
      iconstyle="general_module_icon"
      layoutBoxClass="uiux-form-redesign"
    >
      <RawItemform
        type="add"
        title="Create Raw Item"
        handleToast={handleToast}
        handleStep={handleStep}
      />
    </FormLayout>
  );
};

export default AddrawItem;
